import React, { memo } from 'react';
import { useStyles } from 'uinix-ui';

import { SharedGridProps } from '../../types/SharedGridProps';
import { Box } from '../Box/Box';

export const Grid = memo(
  ({
    align,
    columns = 1,
    columnSpacing,
    columnMinWidth,
    columnWidths,
    columnMaxWidth,
    justify,
    rows,
    rowSpacing,
    width = 'auto',
    ...rest
  }: SharedGridProps) => {
    const styles = useStyles();

    const styleProps = {
      align,
      columns,
      columnSpacing,
      columnWidths,
      columnMinWidth,
      columnMaxWidth,
      justify,
      rows,
      rowSpacing,
    };
    return (
      <Box
        {...rest}
        role="grid"
        styles={styles.gridColumns}
        styleProps={styleProps}
        w={width}
      />
    );
  },
);
